/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';
import * as Yup from 'yup';
import clsx from 'clsx';
import { Link, useNavigate } from 'react-router-dom';
import { Field, FormikProvider, useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { ResendVerificationEmail } from '../../../redux/features/auth/authActions';
import { RESEND_VERIFICATION_TITLE } from '../../../utlis/messages';
import SubmitButton from '../../common/SubmitButton';
import FieldInputText from '../../common/FieldInputText';

const resendSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
});

export function ResendVerification() {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const { loading } = useSelector((state: any) => state.resendVerificationSlice);

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: resendSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setSubmitting(true);
      try {
        await dispatch(ResendVerificationEmail(values));
        navigate('/auth/login');
      } catch (error) {
        setStatus('Resend verification failed');
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_password_reset_form'
      onSubmit={formik.handleSubmit}
    >
      <div className='text-center mb-10'>
        <h1 className='text-dark fw-bolder mb-3'>Resend Verification Email</h1>
        <div className='text-gray-500 fw-semibold fs-6'>{RESEND_VERIFICATION_TITLE}</div>
      </div>

      <FieldInputText
        fieldProps={formik.getFieldProps('email')}
        touched={formik.touched.email}
        errors={formik.errors.email}
        type='email'
        name='email'
        label='Email'
        placeholder='Email'
        autoComplete='off'
      />

      <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
        <SubmitButton formik={formik} />
        
        <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_password_reset_form_cancel_button'
            className='btn btn-light me-3'
          >
            Cancel
          </button>
        </Link>
      </div>
    </form>
  );
}